import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import errorBoundary from '@ifeng-fe/errorBoundary';
// import Header from '@ifeng-fe/container_channel/common/client/components/header';
import Footer from '@ifeng-fe/container_channel/common/client/components/footer';

/**
 * for this page
 */
import PhotoNav from './photoNav';
import PhotoBottomInfo from './photoBottomInfo';
import Content from './content';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    render() {
        // console.log('layout=', this.props);
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        return (
            <div className={styles.layout}>
                {/* <Header content={content.nav} /> */}
                <PhotoNav searchData={content.search} ad={content.headerAd} />
                <Content content={content} />
                <Chip
                    id="25021"
                    type="static"
                    title="页尾频道介绍"
                    groupName="凤凰网资讯图片"
                    content={content.photoBottomInfo}>
                    <PhotoBottomInfo />
                </Chip>
                <div className={styles.footerWrapper}>
                    <Chip id="20036" type="struct" title="全站通用页尾导航" groupName="底部" content={content.footer}>
                        <Footer />
                    </Chip>
                    <ChipEdit transform={transform} />
                </div>
            </div>
        );
    }
}

export default errorBoundary(Layout);
